const ERRORS = {
    length: "Поле обязательно для заполнения",
    email: "Неверный e-mail",
};

class ValidationService {
    constructor() {}

    get validators() {
        return {
            required: (value) => {
                return value.trim().length === 0 ? ERRORS.length : "";
            },
            email: (value) => {
                const regex =
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i;

                return regex.test(value.trim()) ? "" : ERRORS.email;
            },
            minLength: (value, length = 2) => {
                return value.trim().length > length ? "" : ERRORS.length;
            },
        };
    }
}

export const validationService = new ValidationService();
